// extracted by mini-css-extract-plugin
export default {"root":"SettingsSecurityChangePassword_root__XPRcW","button":"SettingsSecurityChangePassword_button__qvZgs","fieldItem":"SettingsSecurityChangePassword_fieldItem__ns5f1"};